export default __webpack_public_path__ + "static/media/cog.d5d783f4.svg";